<template>
  <div class="numbers">
    <div ref="carousel">
      <div v-for="(item, index) in items" :key="index">
        <div class="number-container flex">
          <div class="title font-bold color-blue-2">{{item.label}}</div>
          <div class="data color-white" v-html="item.body"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
    }
  },

  created(){
    this.$api.get('/v1/figures')
      .then(({body}) => {
        this.items = body.rows;

        this.$nextTick(() => {
          window.tns({
            container: this.$refs['carousel'],
            autoplay: true,
            autoplayButtonOutput: false,
            items: 1,
            controlsText: ['<i class="las la-angle-left"></i>', '<i class="las la-angle-right"></i>'],
            nav: false,
          });
        }, 0);

      });
  }

}
</script>

<style lang="scss">
.numbers
{
  .tns-ovh
  {
    margin: 0 30px;
  }

  .data
  {
    padding: 5px;

    P
    {
      margin: 0;
    }
  }

}
</style>

<style lang="scss" scoped>
@import "@/sass/_vars.scss";

.numbers
{
  margin-left: 30px;
  flex-grow: 1;

  max-width: 35%;

  @media (min-width:$screen-lg)
  {
    max-width: 400px;
  }

  @media (max-width:$screen-md - 1)
  {
    display: none;
  }

  .number-container
  {
    width: 100%;
    overflow: auto;
  }

  // .title, .data
  // {
  //   // display: inline-block;
  //   // float: left;
  // }

  .title
  {
    text-align: right;
    border-right: 1px solid $white;
    padding: 5px;
  }

  .data
  {
    padding: 5px;

    strong {
      background: red;
    }
  }

}
</style>